// Séances : assainissement de ce qui vient du serveur ou d'un import, cocher / décocher, suppression, plannings multiples.
// « Pas encore acquis » : la séance n'a pas pris, on la revoit AU MÊME J le surlendemain, et tout ce qui suit
// dans sa séquence recule d'autant. Le type de la séance ne change pas — c'est bien le même J qu'on rejoue —
// et les séances cochées, ici comme ailleurs, ne bougent jamais.
//
// Renvoie { taches, date, jours, suivantes } ; `date` est null si la séance est déjà au-delà du surlendemain
// (rien à faire, on ne la ramène jamais en arrière).
// Une séance appartient-elle à la suite de `ref` (ce qui doit bouger avec elle) ? Trois règles :
//   - même sous-partie : même itemId (un item non scindé n'a qu'une suite) ;
//   - le renforcement pédiatrie (isDouble) est une suite à part : il partage l'itemId de l'item mais ne le suit pas ;
//   - un item scindé est revu en bloc à partir de J14 (tâches `bloc`, itemId = l'item entier) : ces révisions
//     viennent après toutes ses sous-parties, elles suivent donc chacune d'elles.
window.memeSuite = function(ref, t) {
    if (!!t.isDouble !== !!ref.isDouble) return false;
    if (String(t.itemId) === String(ref.itemId)) return true;
    return !!t.bloc && !ref.isDouble && String(t.baseItemId || t.itemId) === String(ref.baseItemId || ref.itemId);
};

// Révisions en bloc décalées. Un item scindé est revu sous-partie par sous-partie, puis en un bloc à partir de J14
// (tâches `bloc`) : le bloc Jn tombe n jours après le J0 de la dernière sous-partie. Avant le 2026-10-06, déplacer
// à la main un J de sous-partie (et lisser, intensifier, « pas acquis ») ne décalait pas les révisions en bloc :
// elles sont restées à leur date d'origine. Ce contrôle retrouve, pour chaque sous-partie, le J0 qu'implique sa
// dernière révision datée (sa date moins son nombre de jours), garde le plus tardif, et compare la première
// révision en bloc non faite à ce repère. Rien n'est modifié ici : l'appelant montre la liste et décide.
//
// Renvoie [{ base, titre, ecart, type, date, attendue, nb }] : ecart > 0, le bloc vient trop tôt ; < 0, trop tard.
// Un écart de 1 ou 2 jours trop tard est toléré (le lissage décale aussi les blocs d'un jour ou deux, sans dommage).
function nJours(type) { var m = /^J(\d+)$/.exec(type || ''); return m ? parseInt(m[1], 10) : null; }
function decaler(ymd, n) { var d = window.parseDateLocal(ymd); d.setDate(d.getDate() + n); return window.toYYYYMMDD(d); }
function ecartJours(a, b) { return Math.round((window.parseDateLocal(b) - window.parseDateLocal(a)) / 86400000); }
window.blocsDecales = function(taches) {
    var parBase = {};
    taches.forEach(function(t) {
        if (t.isDouble) return;
        var base = String(t.baseItemId || t.itemId);
        (parBase[base] = parBase[base] || []).push(t);
    });
    var sortie = [];
    Object.keys(parBase).forEach(function(base) {
        var liste = parBase[base];
        var blocs = liste.filter(function(t) { return t.bloc && t.status === 'pending' && nJours(t.type) != null; })
            .sort(function(a, b) { return a.date.localeCompare(b.date); });
        var parties = {};
        liste.forEach(function(t) { if (!t.bloc && String(t.itemId) !== base && nJours(t.type) != null) (parties[t.itemId] = parties[t.itemId] || []).push(t); });
        if (!blocs.length || !Object.keys(parties).length) return;
        var repere = null;
        Object.keys(parties).forEach(function(k) {
            var derniere = parties[k].reduce(function(a, b) { return b.date > a.date ? b : a; });
            var j0 = decaler(derniere.date, -nJours(derniere.type));
            if (!repere || j0 > repere) repere = j0;
        });
        var premier = blocs[0], attendue = decaler(repere, nJours(premier.type));
        var ecart = ecartJours(premier.date, attendue);
        if (ecart >= 1 || ecart <= -3) sortie.push({ base: base, titre: premier.titre, ecart: ecart, type: premier.type, date: premier.date, attendue: attendue, nb: blocs.length });
    });
    return sortie.sort(function(a, b) { return a.date.localeCompare(b.date); });
};
// Recale les révisions en bloc non faites des items donnés, de leur écart : les écarts entre blocs sont gardés, les
// séances cochées ne bougent pas, et rien n'est ramené avant `aujourdhui`. Renvoie { taches, items, seances }.
window.recalerBlocs = function(taches, aujourdhui, bases) {
    var choix = {};
    window.blocsDecales(taches).forEach(function(d) { if (!bases || bases.indexOf(d.base) !== -1) choix[d.base] = d; });
    Object.keys(choix).forEach(function(b) {
        var d = choix[b];
        if (d.ecart < 0 && decaler(d.date, d.ecart) < aujourdhui) d.ecart = Math.min(0, ecartJours(d.date, aujourdhui));
    });
    var seances = 0;
    var sortie = taches.map(function(t) {
        var d = t.bloc && t.status === 'pending' && !t.isDouble ? choix[String(t.baseItemId || t.itemId)] : null;
        if (!d || !d.ecart) return t;
        seances++;
        return Object.assign({}, t, { date: decaler(t.date, d.ecart) });
    });
    return { taches: sortie, items: Object.keys(choix).filter(function(b) { return choix[b].ecart; }).length, seances: seances };
};

window.reporterNonAcquis = function(taches, id, aujourdhui, pas) {
    pas = pas > 0 ? pas : 2;
    var cible = taches.find(function(t) { return t.id === id; });
    if (!cible || cible.status !== 'pending') return { taches: taches, date: null, jours: 0, suivantes: 0 };
    var d = window.parseDateLocal(aujourdhui); d.setDate(d.getDate() + pas);
    var nouvelle = window.toYYYYMMDD(d);
    var jours = Math.round((d - window.parseDateLocal(cible.date)) / 86400000);
    if (jours <= 0) return { taches: taches, date: null, jours: 0, suivantes: 0 };

    var item = String(cible.itemId), marque = Date.now(), suivantes = 0;
    var sortie = taches.map(function(t) {
        if (t.status !== 'pending' || String(t.itemId) !== item || t.date < cible.date) return t;
        if (t.id !== cible.id) suivantes++;
        var v = window.parseDateLocal(t.date); v.setDate(v.getDate() + jours);
        return Object.assign({}, t, { date: window.toYYYYMMDD(v), rattrape: t.id === cible.id ? marque : t.rattrape });
    });
    return { taches: sortie, date: nouvelle, jours: jours, suivantes: suivantes };
};

// Répartit des ITEMS sur les jours suivants, un jour sur deux à partir du surlendemain.
//
// `portee` dit sur quoi : 'retard' (les séances d'avant aujourd'hui, le cas courant) ou 'jour' (celles
// d'aujourd'hui, pour pousser une journée qu'on sait perdue alors qu'on n'a aucun retard).
//
// Trois règles :
//   1. seules les séances non faites bougent — une séance cochée garde sa date, toujours ;
//   2. on répartit par ITEM, pas par séance : la plus ancienne séance en retard d'un item donne le décalage,
//      et TOUTE LA SUITE de sa séquence suit du même nombre de jours. Les écarts entre J sont donc conservés
//      tels quels, et aucune séance ne peut se retrouver coincée derrière une autre ;
//   3. les séances déplacées sont marquées (`rattrape`) pour passer en tête de leur journée.
//
// Renvoie { taches, deplacees, items, dates } sans rien enregistrer : l'appelant décide.
// `repartition` dit combien d'items poser sur chaque jour de rattrapage :
//   - un tableau [5, 3, 8] : cinq items à J+2, trois à J+4, huit à J+6 — c'est le réglage à la main ;
//   - un nombre : le même compte sur chaque jour ;
//   - rien : le calcul automatique (une douzaine par jour, de trois à huit jours).
// Un reste non placé va sur le dernier jour : mieux vaut un dernier jour chargé qu'un item oublié en arrière.
window.repartirRetards = function(taches, aujourdhui, pas, portee, repartition) {
    pas = pas > 0 ? pas : 2;
    var duJour = portee === 'jour';
    var retard = taches.filter(function(t) {
        return t.status === 'pending' && (duJour ? t.date === aujourdhui : t.date < aujourdhui);
    });
    if (!retard.length) return { taches: taches, deplacees: 0, items: 0, dates: [], portee: portee || 'retard' };

    // Un item = une ancre, sa séance en retard la plus ancienne. C'est elle qui donne le décalage de la séquence.
    var ancres = {};
    retard.forEach(function(t) {
        var c = String(t.itemId);
        if (!ancres[c] || t.date < ancres[c].date) ancres[c] = t;
    });
    var liste = Object.keys(ancres).map(function(c) { return ancres[c]; })
        .sort(function(a, b) { return a.date.localeCompare(b.date) || String(a.id).localeCompare(String(b.id)); });

    // Combien d'items sur chaque jour. Le plafond de 60 jours n'est là que contre une saisie absurde
    // (un item par jour sur des mois) : au-delà, le rattrapage ne rattrape plus rien.
    var comptes = window.comptesRattrapage(liste.length, repartition);

    // Les dates : surlendemain, puis un jour sur `pas`.
    var dates = [], d = window.parseDateLocal(aujourdhui);
    d.setDate(d.getDate() + pas);
    for (var k = 0; k < comptes.length; k++) { dates.push(window.toYYYYMMDD(d)); d.setDate(d.getDate() + pas); }

    // À quel jour revient chaque item : on remplit les jours dans l'ordre, selon leur compte.
    var placeDe = [], reste = liste.length;
    comptes.forEach(function(c, k) { var pris = Math.min(c, reste); for (var j = 0; j < pris; j++) placeDe.push(k); reste -= pris; });
    while (reste-- > 0) placeDe.push(comptes.length - 1);   // le surplus va sur le dernier jour

    // Décalage de chaque item, en jours.
    var decalage = {}, depuis = {}, utilisees = {};
    liste.forEach(function(ancre, i) {
        var cible = dates[placeDe[i]];
        var jours = Math.round((window.parseDateLocal(cible) - window.parseDateLocal(ancre.date)) / 86400000);
        if (jours <= 0) return;   // déjà au-delà : rien à faire
        decalage[String(ancre.itemId)] = jours;
        depuis[String(ancre.itemId)] = ancre.date;
        utilisees[cible] = (utilisees[cible] || 0) + 1;
    });

    var marque = Date.now(), deplacees = 0;
    var sortie = taches.map(function(t) {
        var c = String(t.itemId), j = decalage[c];
        // La queue suit : toute séance non faite de l'item, à partir de l'ancre, se décale d'autant.
        if (!j || t.status !== 'pending' || t.date < depuis[c]) return t;
        var v = window.parseDateLocal(t.date); v.setDate(v.getDate() + j);
        deplacees++;
        var etaitVisee = duJour ? t.date === aujourdhui : t.date < aujourdhui;
        return Object.assign({}, t, { date: window.toYYYYMMDD(v), rattrape: etaitVisee ? marque : t.rattrape });
    });
    return {
        taches: sortie,
        deplacees: deplacees,
        items: Object.keys(decalage).length,
        comptes: comptes,                                  // ce qui a servi, pour pré-remplir la fenêtre la fois d'après
        dates: Object.keys(utilisees).sort().map(function(x) { return { date: x, n: utilisees[x] }; }),
        portee: portee || 'retard',
    };
};

window.assainirTaches = function(liste) {
    if (!Array.isArray(liste)) return [];
    var out = [];
    liste.forEach(function(t) {
        if (!t || typeof t !== 'object' || Array.isArray(t)) return;
        var id = window.idSur(t.id); if (!id) return;
        t.id = id;
        if (t.itemId != null) t.itemId = window.idSur(t.itemId);
        if (t.baseItemId != null) t.baseItemId = window.idSur(t.baseItemId);
        ['titre', 'matiere', 'type', 'part', 'partName', 'date', 'status', 'label'].forEach(function(k) {
            if (!(k in t)) return;
            if (typeof t[k] !== 'string') t[k] = t[k] == null ? '' : String(t[k]);
            if (t[k].length > 300) t[k] = t[k].slice(0, 300);
        });
        if ('podcastLink' in t) t.podcastLink = window.lienSur(t.podcastLink);
        out.push(t);
    });
    return out;
};
// Sous-parties importées : un numéro d'item → des noms de parties. Rien d'autre.
window.assainirSousParties = function(sp) {
    var out = {};
    if (!sp || typeof sp !== 'object' || Array.isArray(sp)) return out;
    Object.keys(sp).forEach(function(k) {
        if (!/^[0-9]{1,4}$/.test(k) || !Array.isArray(sp[k])) return;
        var noms = sp[k].filter(function(x) { return typeof x === 'string' && x.trim(); }).map(function(x) { return x.trim().slice(0, 120); });
        if (noms.length) out[k] = noms.slice(0, 40);
    });
    return out;
};

window.actions.toggleTask = function(taskId) {
    var avant = window.state.tasks.find(function(t) { return t.id === taskId; });
    window.planningAction((avant && avant.status === 'pending') ? 'Révision cochée' : 'Révision décochée');
    var updated = window.state.tasks.map(function(t) {
        if(t.id === taskId) { t.status = t.status === 'pending' ? 'done' : 'pending'; if (t.status === 'done') window.recordTaskTime(t); }
        return t;
    });
    window.syncWithServer('save_tasks', { tasks: updated }, function() { window.renderContent(); });
};
// Supprime la séquence de révisions d'une carte : l'item (ou la sous-partie) OU son renforcement pédiatrie, jamais les deux.
// Les renforcements pédiatrie partagent l'itemId de l'item d'origine : on distingue par le drapeau isDouble / suffixe _bis.
window.isPediaTask = function(t) { return !!(t && (t.isDouble || String(t.id || '').indexOf('_bis') !== -1)); };
window.actions.deleteTaskSequence = function(ref) {
    ref = String(ref);
    var task = window.state.tasks.find(function(t) { return t.id === ref; });
    var itemId = task ? String(task.itemId) : ref, pedia = task ? window.isPediaTask(task) : false;
    if(confirm(pedia ? "Supprimer le renforcement pédiatrie de cet item (toutes ses révisions) ? L'item d'origine reste planifié." : "Voulez-vous supprimer toutes les révisions de cet item ?" + (window.state.tasks.some(function(t) { return String(t.itemId) === itemId && window.isPediaTask(t); }) ? " Son renforcement pédiatrie est conservé." : ""))) {
        var filtered = window.state.tasks.filter(function(t) { return String(t.itemId) !== itemId || window.isPediaTask(t) !== pedia; });
        window.planningAction(pedia ? 'Suppression d\'un renforcement pédiatrie' : 'Suppression des révisions d\'un item');
        // vider : c'est bien l'utilisateur qui retire la dernière séquence (le serveur refuse sinon une liste vide)
        window.syncWithServer('save_tasks', { tasks: filtered, vider: !filtered.length }, function() {
            window.state.tasks = filtered;
            window.renderContent(); 
        });
    }
};

window.actions.switchPlanning = function(planningId) {
    if (!planningId || planningId === window.state.currentPlanningId) return;
    window.state.currentPlanningId = planningId;
    localStorage.setItem('edn_current_planning_id', planningId);
    window.savePrefs();

    // Les sous-parties sont partagées entre tous les plannings : on ne les recharge pas ici.
    window.state.selectedTaskIds = [];
    window.state.isLoading = true;
    window.renderApp();

    window.syncWithServer('get_tasks', { planning_id: planningId }, function(data) {
        window.state.isLoading = false;
        // Assainies comme au chargement initial et à l'import : leurs identifiants entrent dans des attributs.
        window.state.tasks = window.assainirTaches((data.tasks && Array.isArray(data.tasks)) ? data.tasks : []);
        window.renderApp();
    });
};

window.actions.createPlanning = function() {
  window.dialogue.demander({ titre: 'Nouveau planning', label: 'Nom du planning', valeur: 'Planning ' + (window.state.plannings.length + 1), ok: 'Créer' }).then(function(name) {
    if (!name) return;
    var newId = 'plan_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
    window.state.plannings.push({ id: newId, name: name.trim() });
    window.savePlanningsMetaLocal(window.state.plannings);
    window.syncWithServer('create_planning', { planning_id: newId, name: name.trim() });
    window.actions.switchPlanning(newId);
  });
};

window.actions.renameCurrentPlanning = function() {
    var current = window.state.plannings.find(function(p){ return p.id === window.state.currentPlanningId; });
    window.dialogue.demander({ titre: 'Renommer le planning', label: 'Nouveau nom', valeur: current ? current.name : '', ok: 'Renommer' }).then(function(name) {
        if (!name || !name.trim()) return;
        if (current) current.name = name.trim();
        window.savePlanningsMetaLocal(window.state.plannings);
        window.syncWithServer('rename_planning', { planning_id: window.state.currentPlanningId, name: name.trim() });
        window.renderPlanningBar();
    });
};

window.actions.deleteCurrentPlanning = function() {
    if (window.state.plannings.length <= 1) {
        window.dialogue.alerter({ titre: 'Dernier planning', message: 'Impossible de supprimer le dernier planning restant. Crée-en un autre avant de supprimer celui-ci.' });
        return;
    }
    var current = window.state.plannings.find(function(p){ return p.id === window.state.currentPlanningId; });
    window.dialogue.confirmer({ titre: 'Supprimer ce planning ?', message: 'Le planning « ' + (current ? current.name : '') + ' » et toutes ses révisions seront supprimés définitivement.', ok: 'Supprimer', danger: true }).then(function(oui) {
    if (!oui) return;

    var deletedId = window.state.currentPlanningId;
    window.state.plannings = window.state.plannings.filter(function(p){ return p.id !== deletedId; });
    window.savePlanningsMetaLocal(window.state.plannings);
    localStorage.removeItem(window.getPlanningTasksKey(deletedId));
    window.syncWithServer('delete_planning', { planning_id: deletedId });

    window.state.currentPlanningId = null;
    window.actions.switchPlanning(window.state.plannings[0].id);
    });
};

// --- EXPORT / IMPORT DE PLANNINGS ---
window.actions.exportCurrentPlanning = function() {
    var s = window.state;
    var current = s.plannings.find(function(p){ return p.id === s.currentPlanningId; });
    var payload = {
        format: 'edn-planner-export',
        version: 1,
        exportedAt: new Date().toISOString(),
        planningName: current ? current.name : 'Planning',
        tasks: s.tasks,
        subParts: s.subParts
    };
    var blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    var safeName = (current ? current.name : 'planning').replace(/[^a-z0-9_\-]+/gi, '_');
    a.download = 'edn-planning-' + safeName + '-' + window.toYYYYMMDD(new Date()) + '.json';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function(){ URL.revokeObjectURL(url); }, 1000);
};

window.actions.triggerImportPlanning = function() {
    var input = document.getElementById('planning-import-input');
    if (input) input.click();
};

window.actions.handleImportPlanningFile = function(fileInput) {
    var file = fileInput.files && fileInput.files[0];
    if (!file) return;
    var reader = new FileReader();
    reader.onload = function(e) {
        var data;
        try { data = JSON.parse(e.target.result); } catch(err) { window.dialogue.alerter({ titre: 'Fichier invalide', message: 'Ce fichier n\'est pas un JSON valide.' }); return; }
        if (!data || !Array.isArray(data.tasks)) { window.dialogue.alerter({ titre: 'Fichier invalide', message: 'Structure de planning non reconnue.' }); return; }

        window.dialogue.demander({ titre: 'Importer un planning', label: 'Nom du planning importé', valeur: data.planningName || 'Planning importé', ok: 'Importer' }).then(function(name) {
        if (!name || !name.trim()) return;

        var newId = 'plan_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
        window.state.plannings.push({ id: newId, name: name.trim() });
        window.savePlanningsMetaLocal(window.state.plannings);
        // Les sous-parties importées enrichissent le magasin global partagé (pas de magasin par planning).
        // Le fichier a pu être écrit par n'importe qui : ses tâches et ses sous-parties sont assainies avant
        // d'être enregistrées et dessinées, exactement comme ce qui arrive du serveur.
        var tachesImportees = window.assainirTaches(data.tasks);
        var sousPartiesImportees = window.assainirSousParties(data.subParts);
        if (Object.keys(sousPartiesImportees).length) {
            Object.assign(window.state.subParts, sousPartiesImportees);
            window.actions.saveSubParts();
        }
        // Dans l'ordre, pas en parallèle : la fiche du planning, puis ses tâches, puis l'ouvrir. Lancés ensemble,
        // l'enregistrement des tâches pouvait précéder la création du planning et le planning importé s'ouvrait vide.
        window.syncWithServer('create_planning', { planning_id: newId, name: name.trim() }, function() {
            window.syncWithServer('save_tasks', { tasks: tachesImportees, planning_id: newId }, function() {
                window.actions.switchPlanning(newId);
            });
        });
        });
    };
    reader.readAsText(file);
    fileInput.value = '';
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const assainirTaches = window.assainirTaches;
export const assainirSousParties = window.assainirSousParties;
export const isPediaTask = window.isPediaTask;

// Combien d'items sur chaque jour de rattrapage. Fonction pure, sortie toujours propre : au moins un jour, des
// comptes entiers positifs, au plus 60 jours, et assez de places pour tout le monde (le dernier jour absorbe).
window.comptesRattrapage = function(nItems, repartition) {
    if (nItems <= 0) return [];
    var c;
    if (Array.isArray(repartition) && repartition.length) {
        c = repartition.map(function(x) { return Math.max(0, Math.floor(x) || 0); }).slice(0, 60);
        if (!c.some(function(x) { return x > 0; })) c = null;   // que des zéros : réglage vide, on retombe sur l'automatique
    } else if (repartition > 0) {
        var n = Math.max(1, Math.min(60, Math.ceil(nItems / Math.floor(repartition))));
        c = []; for (var i = 0; i < n; i++) c.push(Math.floor(repartition));
    }
    if (!c) {
        // Automatique : une douzaine d'items par jour, jamais moins de 3 jours ni plus de 8.
        var nd = Math.max(1, Math.min(Math.max(3, Math.min(8, Math.ceil(nItems / 12))), nItems));
        var base = Math.floor(nItems / nd), sup = nItems % nd;
        c = []; for (var k = 0; k < nd; k++) c.push(base + (k < sup ? 1 : 0));
    }
    return c;
};

// Priorité de révision d'un item, de 0 (jamais réussi) à 1 (acquis), pour l'ordre des séances d'une journée.
//
// Ce n'est PAS le pourcentage affiché sur la ligne, et c'est voulu. Une seule réponse fausse donne un taux brut
// de 0 % : sur cette seule base, un item vu une fois passerait devant un item raté dix fois. On ramène donc la
// mesure vers le milieu à proportion de ce qu'on sait d'elle — une observation fictive à 0,5 s'ajoute au
// poids réel. Un historique fourni garde son verdict ; une mesure isolée pèse moins fort. Un item sans aucune
// observation vaut exactement 0,5 : il ne monte pas en tête comme s'il était raté, et ne descend pas non plus.
// (Le poids w porte déjà la décroissance par demi-vie de 45 jours : un mauvais score d'il y a six mois pèse peu.)
window.prioriteReussite = function(m) {
    if (!m || !m.n || !(m.w > 0)) return 0.5;
    return (m.ws + 0.5) / (m.w + 1);
};

// Ordre des séances À L'INTÉRIEUR d'une journée. Fonction pure : les deux accès au monde extérieur (le partiel
// d'une séance, la maîtrise d'un item) sont passés en paramètres, ce qui la rend testable sans état global.
//
// Elle ne fait que RANGER une liste déjà constituée : aucune date n'est touchée, aucune séance ne change de
// jour, rien n'est enregistré. C'est de l'affichage, et rien d'autre — les trois vues qui l'appellent
// (Aujourd'hui, Accueil, Calendrier) lui passent les séances d'un seul jour et affichent ce qu'elle rend.
//
// Les critères, du plus fort au plus faible :
//   1. une séance rattrapée passe devant — c'est ce qu'on vient faire ce jour-là ;
//   2. les séances d'un partiel qui approche, le partiel le plus proche d'abord ;
//   3. le moins bien réussi d'abord, ce qui met le travail qui compte en haut de l'écran ;
//   4. à égalité, l'ordre d'origine — le tri reste stable.
window.trierSeancesDuJour = function(liste, partielDe, reussiteDe) {
    return liste.map(function(t, i) {
        var ex = partielDe(t);
        return { t: t, i: i, d: ex ? ex.date : null, r: t.rattrape ? 0 : 1, m: reussiteDe(t) };
    }).sort(function(a, b) {
        if (a.r !== b.r) return a.r - b.r;
        if (!!a.d !== !!b.d) return a.d ? -1 : 1;
        if (a.d && b.d && a.d !== b.d) return a.d.localeCompare(b.d);
        if (a.m !== b.m) return a.m - b.m;
        return a.i - b.i;
    }).map(function(x) { return x.t; });
};

// Où en est une séance dans le découpage de son item : « partie 2 sur 5 ».
//
// Une séance d'item scindé porte le nom de sa sous-partie entre crochets à la fin de son titre — c'est ainsi
// que le planning la distingue. Le découpage lui-même est dans state.subParts, mais il arrive qu'il ne soit
// plus mémorisé alors que le planning porte encore les séances : on le reconstitue alors depuis les séances,
// dans l'ordre où elles sont planifiées, ce qui est l'ordre que l'étudiant voit.
// Rend null si l'item n'est pas scindé ; sinon { n, total, nom }, avec n à 0 quand le rang est indéterminable.
window.sousPartieDe = function(tache, subParts, taches) {
    if (!tache) return null;
    var nomDe = function(t) { return (String((t && t.titre) || '').match(/\[([^\]]+)\]\s*$/) || [])[1] || ''; };
    var base = String(tache.baseItemId || tache.itemId), nom = nomDe(tache);
    var liste = (subParts && subParts[base]) || [];

    if (liste.length < 2) {
        var vues = {};
        (taches || []).forEach(function(x) {
            if (String(x.baseItemId || x.itemId) !== base || x.isDouble) return;
            var n = nomDe(x); if (!n) return;
            if (!vues[n] || String(x.date) < vues[n]) vues[n] = String(x.date || '');
        });
        liste = Object.keys(vues).sort(function(a, b) { return (vues[a] || '').localeCompare(vues[b] || '') || a.localeCompare(b); });
        if (liste.length < 2) return null;
    }
    if (!nom) return { n: 0, total: liste.length, nom: '' };

    var i = liste.indexOf(nom);
    if (i < 0) { var cle = nom.toLowerCase(); i = liste.map(function(x) { return String(x).toLowerCase(); }).indexOf(cle); }
    return { n: i + 1, total: liste.length, nom: nom };
};
